import { render, staticRenderFns } from "./dealer_list.vue?vue&type=template&id=b0a86ea4&scoped=true"
import script from "./dealer_list.vue?vue&type=script&lang=js"
export * from "./dealer_list.vue?vue&type=script&lang=js"
import style0 from "./dealer_list.vue?vue&type=style&index=0&id=b0a86ea4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a86ea4",
  null
  
)

export default component.exports